module.exports = "pegasus_template/assets/theme2/small/5.jpg";